import type { NavigateFunction } from 'react-router-dom';

let navigate: NavigateFunction | null = null;


// WARNING: Only to be used on NavigationProvider ONCE. Calling this method will cause a new re-render at the App component level
export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const navigateTo = (to: string) => {
  if (!navigate) {
    if (import.meta.env.DEV) {
      console.warn('[navigation] navigate() not initialized');
    }
    return;
  }

  navigate(to);
};
